<script setup>
import Icon from '@/components/Icon.vue';

const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  intro: { type: String, default: '' },
  items: { type: Array, default: () => [] }, // [{ icon, title, bodyParts?: [{text, highlight}], body?: string }]
});
</script>

<template>
  <div :id="props.id" class="mb-20 scroll-mt-32">
    <h2 class="text-3xl font-serif text-[#1c4848] font-medium tracking-tighter mb-6">
      {{ props.title }}
    </h2>
    <p v-if="props.intro" class="text-base text-[#1c4848]/60 font-normal leading-relaxed mb-8">
      {{ props.intro }}
    </p>

    <div class="space-y-4">
      <div
        v-for="(it, idx) in props.items"
        :key="idx"
        class="group flex items-start gap-4 p-5 rounded-2xl hover:bg-white transition-all duration-300 border border-transparent hover:border-[#1c4848]/5 hover:shadow-sm"
      >
        <div class="w-10 h-10 rounded-full bg-[#1c4848]/5 text-[#1c4848] flex items-center justify-center shrink-0 group-hover:bg-[#1c4848] group-hover:text-[#ecd79f] transition-colors duration-300">
          <Icon v-if="it.icon" :icon="it.icon" class="text-lg" />
          <span v-else class="text-lg">•</span>
        </div>
        <div>
          <h4 v-if="it.title" class="text-sm font-medium text-[#1c4848] mb-1.5">
            {{ it.title }}
          </h4>
          <p class="text-sm text-[#1c4848]/60 font-normal leading-relaxed">
            <template v-if="it.bodyParts?.length">
              <template v-for="(p, pIdx) in it.bodyParts" :key="pIdx">
                <span
                  v-if="p.highlight"
                  class="bg-[#ecd79f]/20 px-1.5 py-0.5 rounded text-[#1c4848] font-medium text-xs"
                >
                  {{ p.text }}
                </span>
                <span v-else>{{ p.text }}</span>
              </template>
            </template>
            <template v-else>
              {{ it.body }}
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

